import { useMemo } from 'react';
import { BodyScrollEvent, CellClickedEvent, ColDef, FirstDataRenderedEvent, GridReadyEvent, GridSizeChangedEvent, ICellRendererParams, IHeaderParams, RowDataChangedEvent, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { GridWrapper } from '@nkr/components/ag-grid/default-style';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { IDashCannedResponse } from '@nkr/models/dash/dash-canned-response';
import { DashCannedResponseType } from '@nkr/models/dash/dash-enums';


interface IProps {
    data            : IDashCannedResponse[],
    setSelectedRow  : (selected: IDashCannedResponse) => void,
}

export const DashCannedResponsesGrid = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
    }

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onRowDataChanged = (e: RowDataChangedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {
        e.api.setColumnDefs(getColumnChanges());
        e.api.sizeColumnsToFit();
    };

    const getColumnChanges = () => {
        let cols: ColDef[] = [
            {
                colId: '1',
                field: 'rank',
                headerName: 'R#',
                headerComponentFramework: (params: IHeaderParams) => <div>R#</div>,
                sortable: false,
                width: 30,
                pinned: 'left',
                pinnedRowCellRendererFramework: () => <div></div>,
                valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1
            },
            {
                field: 'name',
                headerName: 'Name',
                headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Name</SortableHeaderComponent>,
                sortable: true,
                width: 200
            },
            {
                field: 'type',
                headerName: 'Type',
                headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Type</SortableHeaderComponent>,
                sortable: true,
                width: 200,
                valueFormatter: (params) => params.value === DashCannedResponseType.DonorFollowUpSurvey ? 'Donor Follow-Up Survey' : 'General'
            },
            {
                field: 'emailSubject',
                headerName: 'emailSubject',
                headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Email Subject</SortableHeaderComponent>,
                sortable: true,
                width: 400
            },
        ]
        return cols;
    };

    const columnDefs    = useMemo(() => getColumnChanges(), []);
    const rowData       = useMemo(() => props.data, [props.data]);

    return (
        <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ height: '70vh' }}>
            <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                headerHeight={30}
                rowHeight={34}
                enableCellChangeFlash={true}
                suppressCellSelection={true}
                suppressMultiSort={true}
                rowStyle={{ overflow: 'visible' }}
                noRowsOverlayComponentFramework={() => <div>...</div>}
                onGridReady={onGridReady}
                onGridSizeChanged={onGridSizeChanged}
                onFirstDataRendered={onFirstDataRendered}
                onRowDataChanged={onRowDataChanged}
                onRowClicked={(e: CellClickedEvent) => {
                    const data = e.data as IDashCannedResponse;
                    props.setSelectedRow(data);
                }}
                onSortChanged={(e: SortChangedEvent) => e.api.refreshCells()}
            />
        </GridWrapper>
    )
}